import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ENDPOINTS } from '../../service/ENDPOINTS'
import { getReq } from '../../service/API'
import Spinner from '../../components/spinner/Spinner'
import { CheckCircleOutlined } from '@ant-design/icons'
import useSWR from 'swr'
import { Button } from 'antd'
import { useSubject } from '../../hooks/useSubject'

export const SubjectOnboardPage = () => {
  const { projectId, subjectId } = useParams() as { subjectId: string; projectId: string }

  const p = ENDPOINTS.SUBJECTS.qr(projectId, subjectId)

  const [QrScanned, setQrScanned] = useState<boolean>(false)
  const [qrCode, setQRCode] = useState(null)
  const [code, setCode] = useState<string>('')

  const { data: subjectData } = useSubject(projectId, subjectId)
  const interval = !QrScanned ? 1000 : 0

  const { data, error } = useSWR(p, getReq, { refreshInterval: interval })

  useEffect(() => {
    if (data?.data?.qrCode && !data?.data?.QR_SCANNED) {
      setQRCode(data?.data?.qrCode)
      setCode(data?.data?.code)
      setQrScanned(false)
    }

    if (data?.data && data?.data?.QR_SCANNED) {
      setQRCode(null)
      setQrScanned(true)
    }

    if (error) {
      alert(JSON.stringify(error))
    }
  }, [data?.data?.QR_SCANNED, data?.data?.qrCode, data?.data, error])

  const borderColor = '#d6d6d6'

  return (
    <div className="container">
      <div className="row" style={{}}>
        {!QrScanned ? (
          <div
            className="col-12 col-lg-5 py-6 mx-auto mt-5 bg-white rounded-2 "
            style={{
              border: `1px solid ${borderColor}`,
              boxShadow: '0px 10px 6px -8px  rgba(0, 0, 0, 0.06)',
            }}
          >
            <div className="d-flex flex-column align-items-center mb-2">
              <h1 className="text-center mb-2">Assign a device</h1>

              <p className="text-center px-6 mb-3 " style={{ maxWidth: 400 }}>
                <span className="opacity-75">Scan this QR code with the AnneaPRO app to onboard </span>
                <span className="fw-bold">{subjectData.displayId}</span>
              </p>
            </div>

            {qrCode ? (
              <>
                <div className="d-flex justify-content-center ">
                  <div
                    className="rounded-2"
                    style={{
                      border: `1px solid ${borderColor}`,
                      boxShadow: '0px 10px 6px -8px  rgba(0, 0, 0, 0.06)',
                    }}
                  >
                    <img src={qrCode} alt="QR Code" style={{ width: 200, height: 200 }}></img>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center ">
                  <p className="text-bold text-center mt-3 mb-2">Get access to a device</p>
                  <div
                    className="rounded-2 d-inline-block px-4"
                    style={{
                      width: 200,
                      border: `1px solid ${borderColor}`,
                      boxShadow: '0px 10px 6px -8px  rgba(0, 0, 0, 0.06)',
                    }}
                  >
                    <div className="d-flex justify-content-center mt-2">
                      {code &&
                        code.split('').map((item, index) => {
                          return (
                            <h3 key={index} className="text-center mx-1">
                              {item}
                            </h3>
                          )
                        })}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <p className="text-center p-small px-4 mt-4 opacity-75 " style={{ maxWidth: 400 }}>
                    {
                      "If the QR code scan encounters an error, retry by navigating to 'Participants > View Participant.' If the issue persists, try another device."
                    }
                  </p>
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <Link to={`../view/${subjectId}`}>
                    <Button type="link">Back to participant details</Button>
                  </Link>
                </div>
              </>
            ) : (
              <div className="bg-white mb-7 mt-4 d-flex align-items-center justify-content-center">
                <Spinner size={10} style={{}}></Spinner>
              </div>
            )}
          </div>
        ) : null}

        {QrScanned === true ? (
          <div
            className="col-5 p-6 mx-auto mt-5 d-flex justify-content-center bg-white rounded-2"
            style={{
              border: `1px solid ${borderColor}`,
              boxShadow: '0px 10px 6px -8px  rgba(0, 0, 0, 0.06)',
            }}
          >
            <div className=" d-flex align-items-center justify-content-center flex-column ">
              <h2 className="text-center">Device Assignment Complete</h2>

              <div className="d-flex justify-content-center my-3">
                <CheckCircleOutlined style={{ color: '#1aa234', fontSize: '4rem' }} />
              </div>

              <div className="mt-3 ">
                <h5 className="text-center">QR code was scanned successfully</h5>
                <p className="mt-3 text-center">
                  Participant has been successfully assigned a device and will now appear in the Participants view which
                  can be accessed via the menu to the left.
                </p>
                <div className="d-flex justify-content-center mt-4">
                  <Link to={`../view/${subjectId}`}>
                    <Button type="primary" className="px-4 py-3">
                      View Participant
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
